import { FilterPanelModule } from './../../ca-shared/filter-panel/filter-panel.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularSplitModule } from 'angular-split';
import { NgbDatepickerModule, NgbAlertModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { ConversationRoutingModule } from './conversation-routing.module';
import { ConversationMainComponent } from './conversation-main/conversation-main.component';
import { SharedModule } from '../shared/shared.module';
import { ConversationListToolbarComponent } from './conversation-list-toolbar/conversation-list-toolbar.component';
import { ConversationMixedListComponent } from './mixed/conversation-mixed-list/conversation-mixed-list.component';
import { CallListComponent } from './call/call-list/call-list.component';
import { ChatListComponent } from './chat/chat-list/chat-list.component';
// tslint:disable-next-line: max-line-length
import { ConversationCommonFilterPanelComponent } from './shared/conversation-common-filter-panel/conversation-common-filter-panel.component';
import { CallFilterPanelComponent } from './call/call-filter-panel/call-filter-panel.component';
import { ChatFilterPanelComponent } from './chat/chat-filter-panel/chat-filter-panel.component';
// tslint:disable-next-line: max-line-length
import { ConversationStandardMixedListComponent } from './mixed/conversation-mixed-list/conversation-standard-mixed-list/conversation-standard-mixed-list.component';
// tslint:disable-next-line: max-line-length
import { ConversationCardMixedListComponent } from './mixed/conversation-mixed-list/conversation-card-mixed-list/conversation-card-mixed-list.component';
import { StandardCallListComponent } from './call/call-list/standard-call-list/standard-call-list.component';
import { StandardChatListComponent } from './chat/chat-list/standard-chat-list/standard-chat-list.component';
import { ConversationBaseListComponent } from './shared/conversation-base-list/conversation-base-list.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CoreModule } from 'src/core/core.module';
import { CaSharedModule } from 'src/ca-shared/ca-shared.module';
import { PlayerModule } from 'src/ca-shared/player/player.module';
import { SelectorModule } from 'src/ca-shared/selector/selector.module';
import { DropdownTreeModule } from 'src/ca-shared/dropdown-tree/dropdown-tree.module';
import { DatetimeRangePickerModule } from 'src/ca-shared/datetime-range-picker/datetime-range-picker.module';
import { UserPhotoModule } from 'src/ca-shared/user-photo/user-photo.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CallTranscriptPanelComponent } from './conversation-transcript/call-transcript-panel/call-transcript-panel.component';
import { NgWizardConfig, NgWizardModule, THEME } from 'ng-wizard';
import { ChatTranscriptPanelComponent } from './conversation-transcript/chat-transcript-panel/chat-transcript-panel.component';
import { ConversationListFilterPanelComponent } from './conversation-list-filter-panel/conversation-list-filter-panel.component';
import { CADatePipe } from 'src/core/pipes/ca-date.pipe';
import { BlockUIModule } from 'ng-block-ui';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReasonSelectorModule } from 'src/ca-shared/reason-selector/reason-selector.module';
import { EvaluationSelectorComponent } from './evaluation/evaluation-selector/evaluation-selector.component';
import { ConversationEvaluationListPanelComponent } from './evaluation/conversation-evaluation-list-panel/conversation-evaluation-list-panel.component';
import { MatSortModule } from '@angular/material/sort';
import { TextareaAutoresizeDirective } from 'src/core/directives/text-area-auto-resize.directive';
import { IconsModule } from 'src/ca-shared/icons/icons.module';
import { ConversationImportCommunicationService } from './conversation-import/conversation-import-communication.service';
import { ConversationImportWizardService } from './conversation-import/conversation-import-wizard.service';
import { ConversationImportComponent } from './conversation-import/conversation-import.component';
import { CallImportStepOne } from './conversation-import/steps/call-steps/step-one/call-import-step-one.component';
import { CallImportStepThree } from './conversation-import/steps/call-steps/step-three/call-import-step-three.component';
import { CallImportStepTwo } from './conversation-import/steps/call-steps/step-two/call-import-step-two.component';
import { ChatImportStepOne } from './conversation-import/steps/chat-steps/step-one/chat-import-step-one.component';
import { ChatImportStepThree } from './conversation-import/steps/chat-steps/step-three/chat-import-step-three.component';
import { ChatImportStepTwo } from './conversation-import/steps/chat-steps/step-two/chat-import-step-two.component';
import { ConversationImportStepZero } from './conversation-import/steps/step-zero/conversation-import-step-zero.component';
import { MeetingTranscriptPanelComponent } from './conversation-transcript/meeting-transcript-panel/meeting-transcript-panel.component';
import { ConversationMeetingListComponent } from './meeting/conversation-meeting-list/conversation-meeting-list.component';
import { StandardMeetingListComponent } from './meeting/standard-meeting-list/standard-meeting-list.component';
import { ConversationExportComponent } from './conversation-export/conversation-export.component';
import { ConversationReportDownloadComponent } from './conversation-report-download/conversation-report-download.component';
import { ConversationListExportReadyNotificationComponent } from './notifications/conversation-list-export-ready-notification/conversation-list-export-ready-notification.component';
import { ConversationListExportFailedNotificationComponent } from './notifications/conversation-list-export-failed-notification/conversation-list-export-failed-notification.component';
import { ConversationCleanerComponent } from './conversation-cleaner/conversation-cleaner.component';
import { StepOneComponent } from './conversation-cleaner/steps/step-one/step-one.component';
import { StepTwoComponent } from './conversation-cleaner/steps/step-two/step-two.component';
import { TranscriptEditorInputComponent } from './transcript-editor-input/transcript-editor-input.component';
import { ConversationDeleteCompletedNotificationComponent } from './notifications/conversation-delete-completed-notification/conversation-delete-completed-notification.component';
import { ConversationEvaluationDetailPanel } from './evaluation/conversation-evaluation-list-panel/conversation-evaluation-detail-panel/conversation-evaluation-detail-panel.component';
import { VideoCallListComponent } from './video-call/video-call-list/video-call-list.component';
import { StandartVideoCallListComponent } from './video-call/video-call-list/standart-video-call-list/standart-video-call-list.component';
import { ConversationCleanerCommunicationService } from './conversation-cleaner/conversation-cleaner-communication.service';
import { CATimePipe } from 'src/core/pipes/ca-time.pipe';
import { ConversationIconContainerModule } from 'src/ca-shared/conversation-icon-container/conversation-icon-container.module';
import { ConversationBatchTaggingCommunicationService } from './conversation-batch-tagging/conversation-batch-tagging-communication.service';
import { ConversationBatchTaggingComponent } from './conversation-batch-tagging/conversation-batch-tagging.component';
import { ConversationBatchTaggingStepTwo } from './conversation-batch-tagging/steps/step-two/conversation-batch-tagging-step-two.component';
import { ConversationBatchTaggingStepOne } from './conversation-batch-tagging/steps/step-one/conversation-batch-tagging-step-one.component';
import { BatchTaggingCompletedNotificationComponent } from './notifications/batch-tagging-completed-notification/batch-tagging-completed-notification.component';
import { BatchTaggingFailedNotificationComponent } from './notifications/batch-tagging-failed-notification/batch-tagging-failed-notification.component';
import { BatchTaggingStartedNotificationComponent } from './notifications/batch-tagging-started-notification/batch-tagging-started-notification.component';
import { EmailListComponent } from './email/email-list/email-list.component';
import { StandartEmailListComponent } from './email/email-list/standart-email-list/standart-email-list.component';
import { AttachedDataSelectorModule } from 'src/ui/attached-data-selector/attached-data-selector.module';
import { ColumnConfiguratorModule } from 'src/ui/column-configurator/column-configurator.module';
import { GenericLookupSelectorModule } from 'src/ui/generic-lookup-selector/generic-lookup-selector.module';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CAFormsModule } from 'src/ca-shared/form/ca-forms.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatSliderModule } from '@angular/material/slider';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';

const ngWizardConfig: NgWizardConfig = {
  theme: THEME.default,
};

@NgModule({
  declarations: [
    ConversationMainComponent,
    ConversationListToolbarComponent,
    ConversationMixedListComponent,
    CallListComponent,
    ChatListComponent,
    ConversationCommonFilterPanelComponent,
    CallFilterPanelComponent,
    ChatFilterPanelComponent,
    ConversationStandardMixedListComponent,
    ConversationCardMixedListComponent,
    StandardCallListComponent,
    StandardChatListComponent,
    ConversationBaseListComponent,
    ConversationImportComponent,
    CallImportStepOne,
    CallImportStepTwo,
    CallImportStepThree,
    CallTranscriptPanelComponent,
    TranscriptEditorInputComponent,
    EvaluationSelectorComponent,
    ChatTranscriptPanelComponent,
    ConversationListFilterPanelComponent,
    ConversationEvaluationListPanelComponent,
    TextareaAutoresizeDirective,
    ConversationImportStepZero,
    ChatImportStepOne,
    ChatImportStepTwo,
    ChatImportStepThree,
    MeetingTranscriptPanelComponent,
    ConversationMeetingListComponent,
    StandardMeetingListComponent,
    ConversationExportComponent,
    ConversationReportDownloadComponent,
    ConversationListExportReadyNotificationComponent,
    ConversationListExportFailedNotificationComponent,
    ConversationCleanerComponent,
    StepOneComponent,
    StepTwoComponent,
    ConversationDeleteCompletedNotificationComponent,
    ConversationEvaluationDetailPanel,
    VideoCallListComponent,
    StandartVideoCallListComponent,
    ConversationBatchTaggingComponent,
    ConversationBatchTaggingStepOne,
    ConversationBatchTaggingStepTwo,
    BatchTaggingCompletedNotificationComponent,
    BatchTaggingFailedNotificationComponent,
    BatchTaggingStartedNotificationComponent,
    EmailListComponent,
    StandartEmailListComponent,
  ],
  imports: [
    CaSharedModule,
    SharedModule,
    CommonModule,
    CoreModule,
    ConversationRoutingModule,
    BlockUIModule,
    AngularSplitModule,
    NgbDatepickerModule,
    NgbNavModule,
    ClipboardModule,
    NgbAlertModule,
    NgScrollbarModule,
    InfiniteScrollDirective,
    MatTooltipModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatTableModule,
    MatCardModule,
    MatListModule,
    MatButtonModule,
    MatSnackBarModule,
    MatSliderModule,
    MatProgressBarModule,
    MatChipsModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSortModule,
    MatRadioModule,
    ReactiveFormsModule,
    FormsModule,
    PlayerModule,
    SelectorModule,
    DropdownTreeModule,
    DatetimeRangePickerModule,
    UserPhotoModule,
    NgbModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    NgWizardModule.forRoot(ngWizardConfig),
    FilterPanelModule,
    NgSelectModule,
    ReasonSelectorModule,
    IconsModule,
    ConversationIconContainerModule,
    AttachedDataSelectorModule,
    ColumnConfiguratorModule,
    GenericLookupSelectorModule,
    NgbModalModule,
    CAFormsModule,
    NgbTooltipModule,
  ],
  exports: [CallTranscriptPanelComponent, TranscriptEditorInputComponent],
  bootstrap: [
    ConversationListExportReadyNotificationComponent,
    ConversationListExportFailedNotificationComponent,
    ConversationDeleteCompletedNotificationComponent,
    BatchTaggingCompletedNotificationComponent,
    BatchTaggingFailedNotificationComponent,
    BatchTaggingStartedNotificationComponent,
  ],
  providers: [
    ConversationImportWizardService,
    CADatePipe,
    CATimePipe,
    ConversationImportCommunicationService,
    ConversationBatchTaggingCommunicationService,
    ConversationCleanerCommunicationService,
  ],
})
export class ConversationModule {}
